<template>
  <div class="navbar">
    <!-- 侧边栏伸缩 -->
    <hamburger :is-active="sidebar.opened" class="hamburger-container" @toggleClick="toggleSideBar" />
    <!--头部 面包屑 -->
    <breadcrumb class="breadcrumb-container" />
    <!-- <a class="cxc-logo" @click="jumpCxc('http://cxc.com.hk/')" href="javascript:void(0);">
        <img :src="imgLogo" alt="">
    </a> -->
    <!-- 登录和退出 -->
    <div class="right-menu" :class="[Balance ? '' : 'active_ba']">
      <div class="userData">
        <span class="name">您好，{{name ||NAME }}({{code ||CODE }})</span>
        <div class="balance">賬戶餘額: HK${{balance ||  Balance}}</div>

      </div>
      <el-button type="info" class="logout" size="small" @click.native="logout">登出</el-button>
      <div class="logout-mobile"  @click="logout">登出</div>
      <div class="lang-all" v-if="false">
        <div class="line-class"></div>
        <div class="lang-box">
            <ul class="lang-ul">
                <li :class="['lang-item', {'active': isEn}]" @click="changeLocale('en')">En</li>
                <li :class="['lang-item', {'active': isZh_tw}]" @click="changeLocale('zh_tw')">繁</li>
            </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
// import { removeToken } from '@/utils/auth'
import { removeToken } from '@/utils/auth-session'
export default {
  data(){
    return{
      isZh_tw: localStorage.getItem("locale") === "zh_tw" ? true : false,
      isEn: localStorage.getItem("locale") === "en" ? true : false,
      NAME:localStorage.getItem("name"),
      CODE:localStorage.getItem("code"),
      Balance:sessionStorage.getItem("balance"),
      // imgLogo:require("../../assets/CXC-logo@4.png"),
    }
  },
  components: {
    Breadcrumb,
    Hamburger
  },
  computed: {

    balance(){
        return this.$store.state.user.balance
    },

    ...mapGetters([
      'sidebar',
      'name',
      'code'
    ]),
    computedByteLen(content) {
      return content.replace(/[^\x00-\xff]/g, '01').length
    }
  },
  created(){


  },
  methods: {
    changeLocale(value) {
       if( localStorage.getItem('locale') == value ) return;
        localStorage.setItem("locale", value);
        this.$i18n.locale = value;
        this[value] = true;
        location.reload();
    },
    toggleSideBar() {
      console.log('=====toggleSideBar')
      this.$store.dispatch('app/toggleSideBar')
    },
    logout() {
      if(sessionStorage.getItem('Mobile')==11){
           window.android_cxc_os.logoutOs();
         removeToken()
      sessionStorage.clear()
      localStorage.clear();
      location.reload();

      }else{
          removeToken()
      sessionStorage.clear()
      localStorage.clear();
      location.reload();
      }

    }
    // async logout() {
    //   await this.$store.dispatch('user/logout')
    //   localStorage.clear();
    //   this.$router.push(`/login?redirect=${this.$route.fullPath}`)
    // }
  }
}
</script>

<style lang="scss" scoped>
.navbar:hover{
  cursor: pointer;
}
.navbar {
  height: 80px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0,21,41,.08);

  .hamburger-container {
    line-height: 76px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background .3s;
    -webkit-tap-highlight-color:transparent;

    &:hover {
      background: rgba(0, 0, 0, .025)
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .cxc-logo{
    width: 80px;
    height: 80px;
    display: inline-block;
    margin-left: 20px;
    position: relative;
    img{
      width: 100%;
      height: 100%;
    }
    .relative-img{
      position: absolute;
      bottom: 0;
      right: 0;
      width: 100%;
      height: 40px;
    }
  }
  .active_ba{
       line-height: 50px;
  }
  .right-menu {
    float: right;
    height: 100%;
    // line-height: 50px;
    display: flex;
    align-items: center;
    margin-right: 20px;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background .3s;

        &:hover {
          background: rgba(0, 0, 0, .025)
        }
      }
    }
    .logout{
      color: #808482;
      background: #F1F7F5;
      border-radius: 3px;
      border: 1px solid #D1D6D4;
    }
    .logout-mobile{
      display: none;
    }
    .userData{
      height: 50px;
      // display: flex;
      // flex-wrap: nowrap;
      // align-items: center;
      .name{
        margin-right: 10px;
        height: 20px;
        font-size: 18px;
        line-height: 20px;
        text-align: center;
        font-family: PingFangSC-Regular, PingFang SC;
      }
      .balance{
        margin-top:10px;
        text-align: right;
        margin-right: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
      }
    }
    .lang-all{
      padding-right:50px;
      height: 50px;
      float: right;
      display: flex;
      justify-content: space-around;
      .line-class {
          width: 1px;
          height: 32px;
          background-color: #999;
          margin:9px 14px;
        }
      .lang-box {
          height: 100%;
          overflow: hidden;
          .lang-ul {
              display: flex;
              height: 100%;
              list-style-type: none;
              overflow: hidden;
              padding: 0;
              margin: 0;
              align-items: center;
              .lang-item {
                  float: left;
                  width: 32px;
                  height: 32px;
                  line-height: 32px;
                  text-align: center;
                  font-size: 18px;
                  color: #888;
              }
              .lang-item + .lang-item {
                  margin-left: 6px;
              }
              .active {
                  background: rgba(82, 114, 233, 1);
                  color: #fff;
              }
          }
      }
    }

  }
}
</style>
